import APIBase from "./APIBase";

/**
 * @typedef RechargesService
 * @type {RechargesService}
 */
export class RechargesService extends APIBase {
	/**
     * @param {string} apiUrl
     * @param { import("../Stores/SessionStore").SessionStore } sessionStore
     **/
	constructor(apiUrl, sessionStore) {
		super(apiUrl + "Recharges", sessionStore);
	}

    async RedeemVoucher(customerId, productId, voucherCodeId, pin, amount) {
        const body = {
            CustomerId: customerId,
            ProductId: productId,
            Pin: pin,
            Amount: amount,
            IsMobile: false,
        };

        if (voucherCodeId) {
            body.VoucherCodeId = voucherCodeId;
        }

        return this.Post("RedeemVoucher", body);
    }

    async CreateRechargeFromVoucher(customerId, productId, voucherCodeId) {
        return this.Post("CreateRechargeFromVoucher?customerId=" + encodeURIComponent(customerId) + "&productId=" + encodeURIComponent(productId) + "&voucherCodeId=" + encodeURIComponent(voucherCodeId));
    }

    async GetFlashAccountPayments(customerId) {
        return this.Get("GetFlashAccountPayments?customerId=" + encodeURIComponent(customerId));
    }

    async InitiateFlashAccountPayment(phoneNumber, productId, voucherCodeId) {
        let url = `InitiateFlashAccountPayment?phoneNumber=${encodeURIComponent(phoneNumber)}&productId=${encodeURIComponent(productId)}`;
        if (voucherCodeId) {
            url += `&voucherCodeId=${encodeURIComponent(voucherCodeId)}`;
        }
        return this.Post(url);
    }
}